{
  "markread": "marcar como lido",
  "newest": "novos",
  "unread": "não lidos",
  "starred": "com estrela",
  "tags": "Marcadores",
  "alltags": "todos os marcadores",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 hora},other {# horas}} atrás",
  "minutes": "{0,plural,one {1 minuto},other {# minutos}} atrás",
  "seconds": "{0,plural,one {1 segundo},other {# segundos}} atrás",
  "star": "marcar com estrela",
  "unstar": "remover estrela",
  "mark": "marcar como lido",
  "unmark": "marcar como não lido",
  "load_img": "carregar Imagens",
  "open_window": "abrir",
  "next": "próximo",
  "searchbutton": "procurar",
  "refreshbutton": "atualizar fontes",
  "settingsbutton": "configurações",
  "logoutbutton": "sair",
  "loginbutton": "entrar",
  "sources": "Fontes",
  "source_add": "adicionar fonte",
  "source_opml": "ou importar arquivo opml ou google reader",
  "source_export": "exportar fontes",
  "source_edit": "editar",
  "source_filter": "Filtro",
  "source_delete": "deletar",
  "source_warn": "realmente deletar esta fonte?",
  "source_new": "nova fonte (não salva)",
  "source_title": "Título",
  "source_tags": "Marcadores",
  "source_comma": "separado por vírgula",
  "source_select": "por favor, selecione a fonte",
  "source_type": "Tipo",
  "source_save": "salvar",
  "source_cancel": "cancelar",
  "source_saved": "salvo",
  "no_entries": "nenhum registro encontrado",
  "more": "mais",
  "login": "entrar",
  "login_username": "usuário",
  "login_password": "senha",
  "no_title": "sem título",
  "error": "um erro ocorreu",
  "share_mail_label": "Compartilhar usando correio eletrônico"
}
